import { render } from "./ActionPublishEvent.vue?vue&type=template&id=32812150"
import script from "./ActionPublishEvent.vue?vue&type=script&lang=js"
export * from "./ActionPublishEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__